
define("json!config/sharedConfig.json", function(){ return {
    "breakpoints": {
        "tablet-landscape": "'(min-width: 1024px) and (orientation : landscape)'",
        "tablet-portrait": "'(min-width: 768px) and (orientation : portrait)'",
        "tablet": "'(min-width: 768px) and (orientation : portrait), (min-width: 1024px) and (orientation : landscape)'",
        "mobile-landscape": "'(max-height: 375px) and (orientation : landscape)'",
        "mobile-portrait": "'(max-height: 900px) and (orientation : portrait)'",
        "mobile-portrait-short": "'(max-height: 480px) and (orientation : portrait)'",
        "mobile-portrait-medium": "'(max-height: 568px) and (orientation : portrait)'",
        "mobile-portrait-large": "'(max-height: 667px) and (orientation : portrait)'",
        "mobile": "'(max-width: 767px) and (orientation : portrait), (max-width: 1023px) and (orientation : landscape)'"
    },
    "transitionTimings": {
        "pop-in": 150,
        "pop-out": 100,
        "fade-in": 150,
        "fade-out": 100
    }
}
;});

